export const environment = {
    production: false,
    appVersion: '3.3.0',
    urls: {
        api: 'https://sdp.n2g-iona-staging.net/v2/',
        auth: 'https://iona-test-staging.wla-backend.de/auth',
        wmsb: 'https://ews.n2g-iona-staging.net/api',
        faq: 'https://iona-dev.wla-backend.de/faq/esc?showNav=true',
        rewriteUrl: 'https://eona-test.wla-backend.de/demo/',
        userGroup: 'https://ews.n2g-iona-staging.net/api',
    },
    isStaging: true,
};


